export default __webpack_public_path__ + "static/media/accounting_point_4.7e799e1b.png";